import { Reveal } from "./Reveal";

const STOPS = [
  {
    title: "Computer Science",
    desc: "Pursuing Computer Science Engineering at Shiv Nadar University, with an expected graduation year of 2029.",
  },
  {
    title: "Software Development",
    desc: "Developing programming skills and exploring data structures, algorithms, object-oriented programming, and practical software development.",
  },
  {
    title: "Entrepreneurship",
    desc: "Selected for the European Innovation Academy Summer Program in Porto in 2026.",
  },
  {
    title: "Fintech",
    desc: "Exploring the BioPay biometric payments concept and working toward an MVP.",
  },
  {
    title: "Engineering",
    desc: "Experimenting with atmospheric water collection and exploring the engineering principles behind condensation and cooling.",
  },
  {
    title: "Sport & Endurance",
    desc: "Participating in state-level and zonal football tournaments, half-marathons, marathons, and Devil’s Circuit.",
  },
];

export const Journey = () => (
  <section id="journey" data-testid="journey-section" className="py-24 md:py-32 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">My Journey</p>
        <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight font-medium text-[#F9F9F9] mt-4">
          Learning by doing.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
        {STOPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.05}>
            <div data-testid={`journey-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="border-l border-white/10 pl-6 md:pl-8">
              <p className="font-mono-alt text-xs text-[#0EA5E9]">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-heading text-xl md:text-2xl font-medium text-[#F9F9F9] mt-2">{s.title}</h3>
              <p className="text-sm md:text-base text-[#A1A1AA] leading-relaxed mt-3">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
